module.exports = __webpack_public_path__ + "static/approves4-299f1306422620f41f5f1953e83786f0.gif";